import * as React from 'react'
import { WhatsAppVerification } from './WhatsAppVerification'

interface WhatsAppAppointmentButtonProps {
  children: React.ReactNode
  className?: string
  message: string
  phoneNumber?: string
}

export function WhatsAppAppointmentButton({ children, className = '', message, phoneNumber = '+50685838056' }: WhatsAppAppointmentButtonProps) {
  const cleanPhoneNumber = phoneNumber.replace(/\D/g, '') // Remover caracteres no numéricos

  return (
    <WhatsAppVerification
      phoneNumber={cleanPhoneNumber}
      message={message}
      className={className}
    >
      {children}
    </WhatsAppVerification>
  )
}
